import { render, staticRenderFns } from "./OCPendientes.vue?vue&type=template&id=352aa892&scoped=true&"
import script from "./OCPendientes.vue?vue&type=script&lang=js&"
export * from "./OCPendientes.vue?vue&type=script&lang=js&"
import style0 from "./OCPendientes.vue?vue&type=style&index=0&id=352aa892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352aa892",
  null
  
)

export default component.exports